import type { Node, NodeProps } from '@xyflow/react';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import { nodeLabel } from '../graphModel';
import { chevronProps, type FlowNodeData } from '../useGraphLayout';
import { KIND_PALETTE } from '../kindPalette';
import { FootLine } from './FootLine';
import { NodeShell } from './NodeShell';

export function EventNode({ data }: NodeProps<Node<FlowNodeData>>) {
  if (data.node.kind !== 'event') return null;
  const { title, date } = data.node;
  return (
    <NodeShell
      icon={CalendarDaysIcon}
      iconClassName="text-slate-600 dark:text-slate-400"
      compactClassName={KIND_PALETTE.event.compact}
      label={nodeLabel(data.node)}
      selected={data.selected}
      focused={data.focused}
      {...chevronProps(data)}
      className="w-50"
    >
      <div className="truncate text-sm font-medium" title={title}>
        {title}
      </div>
      <FootLine text={date} mentions={data.mentions} />
    </NodeShell>
  );
}
